import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-3" }
const _hoisted_5 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_6 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_7 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-lg-21 ant-col-xl-21"
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-lg-3 ant-col-xl-3" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-10" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-14" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_tipo_documento = _resolveComponent("combo-tipo-documento")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.state.computedVisivel,
    "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.computedVisivel) = $event)),
    width: 1200,
    centered: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Cadastro de Pessoas ")
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "ui-button -primary",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.appBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_form_item, { label: "Documento" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_combo_tipo_documento, {
                        valor: _ctx.state.pessoa.tipoDocumento,
                        "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pessoa.tipoDocumento) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CPF)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_a_form_item, { label: "Número" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_cpf, {
                            valor: _ctx.state.pessoa.numeroDocumento,
                            "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pessoa.numeroDocumento) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CNPJ)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, { label: "Número" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_cnpj, {
                            valor: _ctx.state.pessoa.numeroDocumento,
                            "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pessoa.numeroDocumento) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CPF?'ant-col ant-col-xs-24 ant-col-lg-13 ant-col-xl-13':'ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16')
                }, [
                  _createVNode(_component_a_form_item, {
                    label: _ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CPF?'Nome':'Razão Social/Nome da Empresa'
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.pessoa.nome) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.pessoa.nome]
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 2),
                (_ctx.state.pessoa.tipoDocumento === _ctx.ETipoDocumento.CNPJ)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_a_form_item, { label: "Contato" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.pessoa.contato) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.pessoa.contato]
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_form_item, { label: "Ativa" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_sim_nao, {
                        "radio-button": true,
                        valor: _ctx.state.pessoa.status,
                        "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.pessoa.status) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_form_item, { label: "Telefone Principal" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_telefone, {
                        valor: _ctx.state.pessoa.telefone,
                        "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pessoa.telefone) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, { label: "E-mail" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_email, {
                        valor: _ctx.state.pessoa.email,
                        "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.pessoa.email) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_form_item, { label: "Observações" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        rows: 6,
                        placeholder: "Digite aqui",
                        value: _ctx.state.pessoa.observacao,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.pessoa.observacao) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_comunicacao_api, {
        visivel: _ctx.appBase.exibirComunicaoApi,
        "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
        apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
        resposta: _ctx.appBase.resposta
      }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
    ]),
    _: 1
  }, 8, ["visible"]))
}